<template>
    <Form :model="updateForm" :label-width="120"  :rules="formRules" ref="updateStatus">
        <FormItem label="状态更新为" prop="useStatus">
            <Select v-model="updateForm.useStatus" class="item-width">
                <Option value="">请选择</Option>
                <Option v-for="item in statusList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>

        <FormItem label="是否要赔付" prop="needPay">
            <Select v-model="updateForm.needPay" class="item-width" @on-change="getContractList">
                <Option value=''>请选择</Option>
                <Option v-for="item in needPayList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem v-if="updateForm.needPay===1" label="赔付金额（元）" prop="compensate">
            <Input v-model="updateForm.compensate" class="item-width" :number="true"></Input>
        </FormItem>
         <FormItem v-if="updateForm.needPay===1" label="关联合同" prop="contractId">
            <Select v-model="updateForm.contractId" class="item-width">
                <Option value="">请选择</Option>
                <Option v-for="item in contractList" :value="item.contractId" :key="item.contractId">{{item.contractNumber+'('+item.houseRoomNo+')'}}</Option>
            </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
            <Input v-model="updateForm.remark" type="textarea" :rows="6" class="area-width"></Input>
        </FormItem>
    </Form>
</template>
 
<script type="text/ecmascript-6">
import { getContract } from 'api/archives'
export default {
    props: {
      n:{
        type:Number,
        default:0
      },
    statusList:{
        type:Array,
        default:null
    },
    configAreaFid:{
      type:String,
      default:''
    },
    compensate: {
        type:Number,
        default:null
    }
    },
    watch: {
      n(){
        this.$refs['updateStatus'].resetFields();
        this.updateForm.useStatus = ''
        this.updateForm.needPay = ''
        this.updateForm.compensate =  this.compensate
        this.updateForm.contractId =  ''
        this.updateForm.remark =  ''
        this.contractList = []
      },
      
    },
    data () {
        return {
          contractList:[],
          updateForm:{      
              useStatus:'',
              needPay:'',
              compensate:'',
              contractId:'',
              remark:''    
          },
          needPayList:[
                {
                  text:'是',
                  value:1
                },
                {
                  text:'否',
                  value:0
                }
              ],
          formRules:{
              useStatus:[
                { required: true, message: '请选择状态' ,trigger: 'change',type:'number'}
              ],
              needPay:[
                  {required:true, message: '请选择是否赔付', trigger: 'change',type:'number'}   
              ],
              compensate:[
                  { required: true,  message: '请输入赔付金额', trigger: 'blur',type: 'number' }
              ],
              contractId:[
                  { required: true, message: '请选择合同' ,trigger: 'change'}
              ]
          }
        }
    },
    methods: {
      getContractList(){
        if(this.updateForm.needPay===1 && this.contractList.length===0){
          getContract({roomId:this.configAreaFid}).then( res=> {
            this.contractList = res.data
            }).catch( (err)=> {
              console.log('error:当前房间没有有效合同，无法赔付')
            })
        }
        
      },
      formValidate() {     
          let obj = {}
          this.$refs['updateStatus'].validate( bool => {
              if(bool){ 
                for(let key in this.updateForm){
                  if(key==='needPay'){
                    let value = this.updateForm[key] ? true :false
                    this.$set(obj,key,value)
                  }else {
                      this.$set(obj,key,this.updateForm[key])
                  }
                }
              }else{
                  obj = false
              }
          })
          return obj
      }
    }
}
</script>
 
<style lang="css" scoped>
.item-width{
    width: 200px;
}
.area-width{
    width: 324px;
}
</style>